import { Switchboard } from "../../events";
export class LayerUIFactory {
    constructor() { }
    static construct_ui_for(layer) {
        const cls_string = layer.visible ? 'layer active' : 'layer';
        const ui_parent = $(`<div class="${cls_string}"></div>`);
        const input = LayerUIFactory.construct_input(layer);
        input.on('click', (e) => {
            layer.visible = e.target.checked;
            if (layer.is_base) {
                if (!LayerUIFactory.multiBaseLayersEnabled)
                    ui_parent.trigger('base_layer_select', [layer.name, layer.visible]);
                LayerUIFactory.base_layer_change_broadcaster.emit('base_layer_changed', layer);
            }
            ui_parent.toggleClass('active', layer.visible);
        });
        const label = LayerUIFactory.construct_label(layer, input);
        ui_parent.append(label);
        if (!layer.is_base) {
            const vertical_ellipses = $(`<span style="cursor:move; float:right; display:none">&#8942;&#8942;</span>`);
            ui_parent.append(vertical_ellipses);
            const placeholder_div = $(`<div id="placeholder_div" style="border:solid 1px #707070; margin:0; border-radius:2px; width:${260}px; height:${28}px; display:none"/>`);
            ui_parent.append(placeholder_div);
        }
        return ui_parent;
    }
    static construct_label(layer, input) {
        const element = $(`<label></label>`);
        const name_elem = $(`<span>${layer.name}</span>`);
        const loader = LayerUIFactory.construct_loading_indicator(layer);
        element.append(input);
        element.append(name_elem);
        element.append(loader);
        if (layer.parsing_failed) {
            element.css('cursor', 'not-allowed');
            element.addClass('crossed-out');
            element.attr("title", "Not available");
            element.prop('disabled', true);
        }
        return element;
    }
    static construct_input(layer) {
        const typ = (!LayerUIFactory.multiBaseLayersEnabled && layer.is_base) ? 'radio' : 'checkbox';
        const name = layer.is_base ? 'baseLayers' : layer.name;
        const element = $(`<input type="${typ}" id="${layer.layer_id}" name="${name}" value="${layer.layer_id}" />`);
        if (layer.parsing_failed) {
            element.prop('disabled', true);
            element.prop('checked', false);
            element.attr("title", "Not available");
        }
        else {
            if (layer.visible) {
                setTimeout(() => element.trigger('click'), 200);
            }
        }
        return element;
    }
    static construct_loading_indicator(layer) {
        const loader = $(`<div data-loader-ref="${layer.layer_id}" class="layer_loading_indicator hidden"></div>`);
        return loader;
    }
}
LayerUIFactory.base_layer_change_broadcaster = Switchboard.get_emitter("BASE_LAYER_CHANGED");
LayerUIFactory.multiBaseLayersEnabled = false;
